<template>
  <v-container fluid v-if="sprint != null">
    <v-layout row wrap>
      <sprint-edit-fields v-model="sprint" type="edit"></sprint-edit-fields>
    </v-layout>
  </v-container>
</template>

<script>
import SprintEditFields from '@/components/SprintEditFields.vue';

export default {
  name: 'EditSprintView',
  components: { SprintEditFields },
  computed: {
    sprint: {
      get() {
        return this.$store.getters.getSprint(this.$route.params.id);
      },
      set(value) {
        this.$store.commit('updateSprint', value);
        this.$router.push({ name: 'Sprints' });
      },
    },
  },
};
</script>
